import { useEffect, useReducer } from 'react';
import isEqual from 'lodash/isEqual';

const ACTIONS = {
  SET_IDS: 'SET_IDS',
  SELECT: 'SELECT',
  SELECT_ALL: 'SELECT_ALL',
  DESELECT: 'DESELECT',
  DESELECT_ALL: 'DESELECT_ALL',
};

const reducer = (state, action) => {
  const { type, data } = action;
  switch (type) {
    case ACTIONS.SET_IDS: {
      return !isEqual(state.ids, data) ? { ...state, ids: data } : state;
    }
    case ACTIONS.SELECT: {
      const selected =
        state.selected.indexOf(data) === -1
          ? [...state.selected, data]
          : state.selected;
      return {
        ...state,
        selected,
        excluded: state.excluded.filter(item => item !== data),
      };
    }
    case ACTIONS.SELECT_ALL:
      return { ...state, isSelectAll: true, selected: [], excluded: [] };
    case ACTIONS.DESELECT: {
      const excluded =
        state.excluded.indexOf(data) === -1
          ? [...state.excluded, data]
          : state.excluded;
      return {
        ...state,
        excluded,
        selected: state.selected.filter(item => item !== data),
      };
    }
    case ACTIONS.DESELECT_ALL:
      return { ...state, isSelectAll: false, selected: [], excluded: [] };
    case ACTIONS.LOAD_FAIL:
      throw new Error('Ids can not be loaded');
    default:
      throw new Error();
  }
};

export const useSelection = (ids = []) => {
  const [state, dispatch] = useReducer(reducer, {
    ids: [],
    isSelectAll: false,
    selected: [],
    excluded: [],
  });

  useEffect(() => {
    dispatch({ type: ACTIONS.SET_IDS, data: ids });
  }, [ids]);

  const selectAll = () => {
    dispatch({ type: ACTIONS.SELECT_ALL });
  };

  const deselectAll = () => {
    dispatch({ type: ACTIONS.DESELECT_ALL });
  };

  const select = id => {
    dispatch({ type: ACTIONS.SELECT, data: id });
  };

  const deselect = id => {
    dispatch({ type: ACTIONS.DESELECT, data: id });
  };

  const getSelectedIds = () => {
    return state.isSelectAll
      ? state.ids.filter(id => state.excluded.indexOf(id) === -1)
      : state.ids.filter(
          id =>
            state.excluded.indexOf(id) === -1 &&
            state.selected.indexOf(id) !== -1
        );
  };

  const isSelected = id => {
    return state.isSelectAll
      ? state.excluded.indexOf(id) === -1
      : state.excluded.indexOf(id) === -1 && state.selected.indexOf(id) !== -1;
  };

  return [
    { selectAll, deselectAll, select, deselect, getSelectedIds, isSelected },
  ];
};
